/* Structure that represent events happening on 1 date. The app shows a structure
   with top most groups and direct groups, groups in between are not taken into account. */
import { compareEventStartTimes } from '../libs/dateTimeUtilities';
import YPEventGroupObject, { sortEventsOnAnnouncedStartTime } from './YPEventGroupObject';

export default class YPEventsAndGroupsStructure {
  constructor(listOfEvents) {
    this.sortedEvents = this.sortEventsComparingStartTimes(listOfEvents);
    this.listOfTopEntities = this.#createYPEventGroupObjects();
    this.sortEventsAndGroups();
  }

  #createYPEventGroupObjects() {
    const groupIDToYPEventGroupMapping = {};
    /* Entities with no parents */
    const listOfTopEntities = [];
    this.sortedEvents.forEach((event) => {
      if (event.isPartOfGroup()) {
        const { directGroupID, topGroupID } = event;
        if (directGroupID) {
          let directGroupObject = groupIDToYPEventGroupMapping[directGroupID];
          if (!directGroupObject) {
            directGroupObject = new YPEventGroupObject(
              directGroupID,
              event.directGroupName,
              [event]
            );
            groupIDToYPEventGroupMapping[directGroupID] = directGroupObject;
            if (!topGroupID) listOfTopEntities.push(directGroupObject);
          } else {
            directGroupObject.addChild(event);
          }
          if (topGroupID) {
            let topGroupObject = groupIDToYPEventGroupMapping[topGroupID];
            if (!topGroupObject) {
              topGroupObject = new YPEventGroupObject(topGroupID, event.topGroupName, []);
              groupIDToYPEventGroupMapping[topGroupID] = topGroupObject;
              listOfTopEntities.push(topGroupObject);
            }
            if (
              !topGroupObject.hasChildWithPredicate((child) =>
                child.equal(directGroupObject)
              )
            )
              topGroupObject.addChild(directGroupObject);
          }
        }
      } else {
        listOfTopEntities.push(event);
      }
    });
    return listOfTopEntities;
  }

  hasEvents() {
    return this.sortedEvents.length > 0;
  }

  getNumberOfEvents() {
    return this.listOfTopEntities.reduce(
      (total, eventOrGroup) =>
        total + (eventOrGroup.isGroup() ? eventOrGroup.getNumberOfAllChildren() : 1),
      0
    );
  }

  isEventOrGroupFollowedByGroup(indexOfNextEventOrGroup) {
    return this.listOfTopEntities[indexOfNextEventOrGroup].isGroup();
  }

  isLastEventInStructure(index) {
    return index === this.listOfTopEntities.length - 1;
  }

  doForEachEventOrGroup(groupCallback, eventCallback, limit = false) {
    let currentLimit = 0;
    return this.listOfTopEntities.map((eventOrGroup, index) => {
      if (!limit || currentLimit < limit) {
        if (eventOrGroup.isGroup()) {
          const limitForChildGroup = limit - currentLimit;
          currentLimit += eventOrGroup.getNumberOfAllChildren();
          if (limit !== false) eventOrGroup.setLimitedEventsView(limitForChildGroup);
          const resultOfCallback = groupCallback(eventOrGroup, index);
          eventOrGroup.resetLimitedEventsView();
          return resultOfCallback;
        }
        currentLimit += 1;
        return eventCallback(eventOrGroup, index);
      }
      return null;
    });
  }

  sortEventsComparingStartTimes(events) {
    return events.sort((e1, e2) => {
      const timeDiff = compareEventStartTimes(e1, e2);
      if (timeDiff === 0) {
        return e1.compareEventNames(e2);
      }
      return timeDiff;
    });
  }

  sortEventsAndGroups() {
    this.listOfTopEntities.sort(sortEventsOnAnnouncedStartTime);
  }
}
